// // XNGAGE CONFIDENTIAL
// // __________________________
// //
// // Copyright (C) 2024 Xngage - All Rights Reserved
// //
// // All code or information contained herein is, and remains the
// // property of Xngage LLC and its customers.  The intellectual
// // and technical concepts contained are proprietary to Xngage LLC
// // and may be covered by U.S. and Foreign Patents, patents in
// // process, and are protected by trade secret or copyright law.
// // Dissemination of this information or reproduction of this material
// // is strictly forbidden unless prior written permission is obtained
// // from Xngage LLC.
// //

import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { searchWithinStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListSearchWithin";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, getInputStyleWithIcon, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

searchWithinStyles.searchTextField = {
    ...mergeWithCss(getInputStyleWithIcon(), {
        labelProps: {
            size: fontConfig.fontSize.xSmall,
            lineHeight: fontConfig.lineHeight.xSmall,
            color: "common.ui6",
        },
        cssOverrides: {
            formField: css`
                margin-bottom: 8px;
            `,
        },
    } as TextFieldPresentationProps),
};

searchWithinStyles.titleText = {
    variant: "h6",
    size: fontConfig.fontSize.xSmall,
    lineHeight: fontConfig.lineHeight.xSmall,
    color: "common.ui6",
};

searchWithinStyles.searchWrapper = {
    css: css`
        padding: 8px;
        ${xScreen("lte", "md")} {
            padding: 0 0 8px;
        }
    `,
};

searchWithinStyles.wrapper = {
    css: css`
        border: 1px solid ${color("common.border")};
        div:empty {
            display: none;
        }
        ${xScreen("lte", "md")} {
            border: 0;
        }
        @media print {
            display: none;
        }
    `,
};
